import { MapfreButtonComponent } from '../../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { MapfreLoadingComponent } from '../../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalOptions, AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLoadingComponent, MapfreModalComponent, MapfreButtonComponent],
  selector: 'app-autopay-enroll-modal',
  templateUrl: './autopay-enroll-modal.component.html',
  styleUrls: ['./autopay-enroll-modal.component.css'],
})
export class AutopayEnrollModalComponent implements OnInit{
  @Input() policy: any;
  @Input() action: 'enroll' | 'edit';
  @Output() enrollEvent: EventEmitter<string> = new EventEmitter();
  enrollEditModalOptions: ModalOptions;
  modalIcon: string;
  hideModal: boolean;
  isAcmic: boolean;
  loading = false;

  constructor(
    private acmicService: AcmicService,
  ) {}

  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();

    if(this.action === 'enroll'){
      this.enrollEditModalOptions = new ModalOptions({
        additionalClasses:
          'modal-medium cancel-enroll modal-dialog modal-center-on-page',
        additionalButtonClasses:
          'basic primary x-small-btn manage-ap-btn enroll-ap-btn',
        animatePosition: 'center',
        buttonCopy: 'ENROLL',
        modalId: 'enEnrollModal',
        typeOfModal: 'default',
        modalName: 'autopay_enroll',
      });
    } else{
      this.enrollEditModalOptions = new ModalOptions({
        additionalClasses:
          'modal-medium cancel-enroll modal-dialog modal-center-on-page',
        additionalButtonClasses:
          'edit-ap-btn ghost secondary x-small-btn manage-ap-btn',
        animatePosition: 'center',
        buttonCopy: 'EDIT',
        modalId: 'unEnrollModal',
        modalTranslateCopy: '',
        typeOfModal: 'default',
        modalName: 'autopay_edit',
      });
    }

    this.modalIcon = this.isAcmic 
                        ? './assets/img/images/unenroll-modal-acmic.svg'
                        : './assets/img/images/unenroll-modal-ma.svg';
  }

  resetHideModal(): void {
    this.hideModal = !this.hideModal;
  }

  hideModalAction(event): void {
    if (event) {
      this.hideModal = !this.hideModal;
    }
  }

  onActionClick(){
      this.enrollEvent.emit(this.action.toUpperCase());
  }
}
